// ModalAddRemoveRow

const addRow = (state) => {

  const num = state.rowNum;
  const newValue = Array(state.headers.length - 1).fill("");
  const values = [...state.values];
  values.splice(num, 0, newValue.flat());

  const checkHeaders = state.headers.filter((el) => el === "").length
    ? false
    : true;

  const checkVaules = values.map(el => el.filter(i => i === "").length > 0).filter(ii => ii === true).length
    ? false
    : true;

  return {
    ...state,
    alertTable: false,
    alertStatus: null,
    values,
    checkHeaders,
    checkVaules
  }
}


export default addRow